import colors from '@sportninja/common/constants/appColors'
import type { SpotsTone } from '@sportninja/common/features/organization/registration/utils/availability'
import type { OrgRegistrationBadge } from '@sportninja/common/features/organization/registration/utils/cardModel'

/** The countdown's color — "9 days", "Opens In", "Closed On" — per status. */
export const COUNTDOWN_COLORS: Record<OrgRegistrationBadge, string> = {
  open: colors.SUCCESS_100,
  closingSoon: colors.WARNING_200,
  upcoming: colors.INFO_100,
  past: colors.NEUTRAL_40,
}

/** Spots left, by how full the division is. */
export const SPOTS_COLORS: Record<SpotsTone, string> = {
  available: colors.SUCCESS_100,
  unlimited: colors.SUCCESS_100,
  low: colors.WARNING_200,
  full: colors.NEUTRAL_50,
}
